import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { localizeString } from '../../../../utils'
import { useStatusPageQuery } from './StatusPage.generated'
import { Component } from './StatusPageComponents/Component'
import Wrapper, { LoadingWrapper } from '../../../../utils/Wrapper'

export function StatusPageDetail() {
  const [t] = useTranslation('common')
  const { data, loading } = useStatusPageQuery()
  const { componentId, day, eventId } = useParams()

  if (loading)
    return <LoadingWrapper title={t('status_page.title')} subtitle="..." />

  const component = data.Profile.statusPage.components.find(
    (_) => _._id === componentId
  )

  return (
    <Wrapper
      back="/status-page"
      title={t('status_page.title')}
      subtitle={t('status_page.detail_desc', {
        component: localizeString(component.name),
      })}
    >
      <div>
        <Component expand day={day} component={component} eventId={eventId} />
      </div>
    </Wrapper>
  )
}
